import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { NbsextratorComponent } from './nbsextrator.component';
import { NbsextratorService } from './nbsextrator.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TabViewModule,
    TableModule,
    ButtonModule,
    CalendarModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    MenuModule,
    MultiSelectModule,
    PanelModule,
    RadioButtonModule,
    CheckboxModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule
  ],
  declarations: [
    NbsextratorComponent
  ],
  exports: [
    NbsextratorComponent
  ],
  providers: [
    MessageService,
    ConfirmationService,
    NbsextratorService
  ]
})
export class NbsextratorModule { }
